import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { CContainer, CSpinner } from "@coreui/react";

// Página pública (sem login) aberta a partir do botão "Website" do template
// de WhatsApp — a Meta bloqueia links wa.me diretamente num botão de
// template, por isso o botão aponta para o domínio do frontend, que
// redireciona de imediato para o wa.me do número recebido no path.
//
// Por agora o número vai diretamente na URL (SAP-166); mais tarde troca-se
// para um token opaco resolvido pelo backend (ligado à oportunidade
// comercial), quando esse módulo estiver disponível nesta branch.
const WhatsappRedirect = () => {
  const { phone } = useParams();
  const digits = (phone || "").replace(/\D/g, "");

  useEffect(() => {
    if (digits) {
      window.location.replace(`https://wa.me/${digits}`);
    }
  }, [digits]);

  return (
    <CContainer
      className="d-flex flex-column align-items-center justify-content-center text-center"
      style={{ minHeight: "100vh" }}
    >
      {digits ? (
        <CSpinner color="primary" />
      ) : (
        <p className="text-medium-emphasis mb-0">
          Este link é inválido.
        </p>
      )}
    </CContainer>
  );
};

export default WhatsappRedirect;
